import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syssf { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '改用ADMSA_程式代號 (SF001) 不可空白'}) 
    @MaxLength(20,{message: '改用ADMSA_程式代號 (SF001) 資料太長'})
    SF001: string = '';            // 改用ADMSA_程式代號 20 join ADMMB   改用ADMSA

    @MaxLength(40,{message: '主程式名稱 (SF002) 資料太長'})
    SF002: string = '';            // 主程式名稱 40 EX:KM_STK.EXE

    @MaxLength(1,{message: '程式型態 (SF003) 資料太長'})
    SF003: string = '1';            // 程式型態 1 [DEF:"1"] 1:內部程式 2:外部DLL 3:主要EXE程式

    @MaxLength(40,{message: 'DLL檔名 (SF004) 資料太長'})
    SF004: string = '';            // DLL檔名 40 

    @MaxLength(255,{message: '備註 (SF005) 資料太長'})
    SF005: string = '';            // 備註 255 


}
